
define('text!common/views/content/share-count-immersive.html',[],function () { return '<%= icon %><span class="sharecount__value sharecount__value--short">0</span> Shares\n';});

